var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTeaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 33,
    width: 9,
    height: 8,
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 33,
    width: 52,
    height: 8,
    fill: "#4C6170"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 40.3993C110.259 40.2585 111.046 40.0204 111.361 39.6849C111.675 39.3385 111.833 38.4455 111.833 37.0059V22.6044C111.833 21.4138 111.654 20.6399 111.298 20.2827C110.951 19.9255 110.186 19.7036 109 19.617V19H117.954V19.617C116.769 19.7036 115.998 19.9255 115.641 20.2827C115.284 20.6399 115.106 21.4138 115.106 22.6044V29.0827H124.878V22.6044C124.878 21.4138 124.705 20.6399 124.359 20.2827C124.013 19.9255 123.242 19.7036 122.046 19.617V19H131V19.617C129.814 19.7036 129.043 19.9255 128.687 20.2827C128.34 20.6399 128.167 21.4138 128.167 22.6044V37.3956C128.167 38.6079 128.34 39.3872 128.687 39.7336C129.043 40.0691 129.814 40.291 131 40.3993V41H122.046V40.3993C123.315 40.2694 124.102 40.0312 124.406 39.6849C124.721 39.3385 124.878 38.4455 124.878 37.0059V30.5439H115.106V37.3956C115.106 38.6079 115.284 39.3872 115.641 39.7336C115.998 40.08 116.769 40.3018 117.954 40.3993V41H109V40.3993Z",
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188 90C188 114.853 167.853 135 143 135C118.147 135 98 114.853 98 90C98 65.1472 118.147 45 143 45C167.853 45 188 65.1472 188 90Z",
    fill: "#4C6170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 131C165.644 131 184 112.644 184 90C184 67.3563 165.644 49 143 49C120.356 49 102 67.3563 102 90C102 112.644 120.356 131 143 131ZM143 135C167.853 135 188 114.853 188 90C188 65.1472 167.853 45 143 45C118.147 45 98 65.1472 98 90C98 114.853 118.147 135 143 135Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4160_81546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 76,
    width: 84,
    height: 66
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.906 84.104L152.863 82.0003L157.546 90.0176L180.273 128.924L183.292 134.093L186.913 129.326L192.519 121.944L207.905 133.226L211.077 135.551L213.456 132.419L219.185 124.876L221.646 121.636L218.365 119.231L203.088 108.029L208.614 100.754L212.348 95.8378L206.334 94.439L161.906 84.104Z",
    fill: "#4C6170",
    stroke: "#4C6170",
    strokeWidth: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4160_81546)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 90,
    r: 43,
    fill: "#4C6170",
    stroke: "white",
    strokeWidth: 4
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161 88L205.428 98.335L183.727 126.907L161 88Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.129 102.753L216 122.457L210.271 130L183.4 110.297L189.129 102.753Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.863 82.0005L212.348 95.838L203.088 108.029L221.646 121.636L211.077 135.552L192.519 121.944L183.292 134.093L152.863 82.0005ZM191.713 116.393L210.271 130L216 122.457L197.442 108.849L205.428 98.3351L161 88.0002L183.727 126.907L191.713 116.393Z",
    fill: "#4C6170"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#FFB60A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTeaser);
export default __webpack_public_path__ + "static/media/circle-teaser.62042944a8e57fb5c854ae06401f0837.svg";
export { ForwardRef as ReactComponent };